"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useExternalLocationAirQuality = void 0;
const react_1 = require("react");
const _1 = require(".");
const useExternalLocationAirQuality = (latitude, longitude) => {
    const [externalAirQuality, setExternalAirQuality] = (0, react_1.useState)();
    const { fetchAirQuality } = (0, _1.useAirQuality)();
    (0, react_1.useEffect)(() => {
        const fetchAirQualityData = async () => {
            if (latitude && longitude) {
                const airQuality = await fetchAirQuality(latitude, longitude);
                if (airQuality) {
                    setExternalAirQuality(airQuality);
                }
            }
        };
        fetchAirQualityData();
    }, [latitude, longitude]);
    return {
        externalAirQuality,
    };
};
exports.useExternalLocationAirQuality = useExternalLocationAirQuality;
